/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank9 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.459 13.036c-.14.232-.306.482-.499.748l-1.29 1.79h1.66l1.17-1.63c.373-.513.66-1.033.86-1.56.2-.533.3-1.023.3-1.47 0-.833-.233-1.48-.7-1.94-.467-.467-1.117-.7-1.95-.7-.533 0-1 .107-1.4.32-.4.213-.71.517-.93.91-.213.387-.32.843-.32 1.37 0 .487.087.91.26 1.27.18.353.433.627.76.82.333.193.727.29 1.18.29.333 0 .633-.073.899-.218zm.673-1.666a1.462 1.462 0 0 1-.442.514 1.36 1.36 0 0 1-.78.23c-.213 0-.403-.05-.57-.15a1.034 1.034 0 0 1-.37-.45 1.623 1.623 0 0 1-.13-.67c0-.413.103-.74.31-.98.213-.24.5-.36.86-.36.367 0 .653.117.86.35.207.233.31.557.31.97 0 .182-.016.364-.048.546z" />
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgRank9 as Rank9 };
